// components/PlayButton.tsx
'use client';

import React from 'react';
interface PlayButtonProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel?: string;
}
const PlayButton: React.FC<PlayButtonProps> = ({
  onClick = e => {
    e.stopPropagation();
  },
  ariaLabel = 'Play video'
}) => {
  return <button onClick={onClick} className="w-7 h-7 relative cursor-pointer hover:opacity-80 transition-opacity" aria-label={ariaLabel} type="button">
      <div className="absolute inset-0 bg-[#020202] bg-opacity-50 rounded-full flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-FFFFFF">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
    </button>;
};
export default PlayButton;